import type React from "react"

import { Stack, Typography } from "@mui/material"

import { Card, ConfidenceChip } from "../../homepage/atoms"
import type { E2SiteRow } from "./schedule-misalignment.types"
import { buildConfidenceBasisPoints, directionalCaveat } from "./schedule-story"
import { ShapDrivers } from "./shap-drivers"
import { WhatGuidesInfo } from "./what-guides-info"

const TONE: Record<E2SiteRow["confidence"], string> = {
  HIGH: "success.main",
  MEDIUM: "warning.main",
  LOW: "divider",
}

export const ConfidenceBasis: React.FC<{
  site: E2SiteRow
  periodLabel: string
}> = ({ site, periodLabel }) => {
  const caveat = directionalCaveat(site)

  return (
    <Card sx={{ p: 2.5, borderLeft: 3, borderColor: TONE[site.confidence] }}>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center", mb: 0.5 }}>
        <Typography
          component="h3"
          sx={{ fontSize: "1.125rem", fontWeight: "bold" }}
          variant="body1"
        >
          What guides our analysis
        </Typography>
        <ConfidenceChip level={site.confidence} />
        <WhatGuidesInfo drivers={site.shap_drivers} />
      </Stack>
      {site.shap_drivers && site.shap_drivers.length > 0 ? (
        <Stack spacing={1}>
          <ShapDrivers drivers={site.shap_drivers} />
          {caveat && (
            <Typography sx={{ color: "text.secondary" }} variant="body2">
              {caveat}
            </Typography>
          )}
        </Stack>
      ) : (
        <Stack component="ul" spacing={0.5} sx={{ m: 0, pl: 3 }}>
          {(site.confidence_basis && site.confidence_basis.length > 0
            ? site.confidence_basis
            : buildConfidenceBasisPoints(site, periodLabel)
          ).map((point) => (
            <Typography component="li" key={point} variant="body2">
              {point}
            </Typography>
          ))}
        </Stack>
      )}
    </Card>
  )
}
